export default function SectionHeading({ overline, title, lead, align = "left", testId }) {
  return (
    <div
      className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""} reveal`}
      data-testid={testId}
    >
      {overline && (
        <p className="text-xs sm:text-sm uppercase tracking-[0.25em] font-semibold text-[#7A1F1F] mb-4">
          {overline}
        </p>
      )}
      <h2 className="font-serif text-4xl sm:text-5xl leading-[1.05] tracking-tight text-[#1A1710]">
        {title}
      </h2>
      {lead && (
        <p className="mt-5 text-base sm:text-lg text-[#6B5F4A] leading-relaxed">
          {lead}
        </p>
      )}
    </div>
  );
}
